<div class="wrapper" id="faacilities">
  <div class="sticky">
    <h2>Bringing the best facilities</h2>
    <div class="tabs">
      <button
        (click)="setActiveTab('Facilities')"
        [class.active]="activeTab === 'Facilities'"
        (click)="scrollToSection('facilities')"
        class="fac-btn"
      >
        Facilities
      </button>
      <button
        (click)="setActiveTab('Activities')"
        [class.active]="activeTab === 'Activities'"
        (click)="scrollToSection('activities')"
        class="act-btn"
      >
        Activities
      </button>
      <button
        (click)="setActiveTab('Infrastructure')"
        [class.active]="activeTab === 'Infrastructure'"
        (click)="scrollToSection('infrastructure')"
        class="infra-btn"
      >
        Infrastructure
      </button>
    </div>
  </div>
  <div class="tab-content">
    <div id="facilities">
      <ng-container *ngIf="activeTab === 'Facilities'">
        <app-template [data]="displayedFacilities"></app-template>
      </ng-container>
    </div>
    <div id="activities">
      <ng-container *ngIf="activeTab === 'Activities'">
        <app-template [data]="displayedActivities"></app-template>
      </ng-container>
    </div>

    <div id="infrastructure">
      <ng-container *ngIf="activeTab === 'Infrastructure'">
        <app-template [data]="displayedInfrastructure"></app-template>
      </ng-container>
    </div>
  </div>
</div>
